/* eslint-disable max-len */
import React from 'react';

const LayoutGridIcon = props => (
  <svg width={50} height={50} viewBox="0 0 50 50" {...props}>
    <path
      fillRule="evenodd"
      fill="currentColor"
      d="M3 2h20a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v20h20V3H3zm24-1h20a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1H27a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v20h20V3H27zM3 26h20a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V27a1 1 0 0 1 1-1zm0 1v20h20V27H3zm24-1h20a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1H27a1 1 0 0 1-1-1V27a1 1 0 0 1 1-1zm0 1v20h20V27H27z"
    />
  </svg>
);

export default LayoutGridIcon;
